import { render } from "./DiscountSale.vue?vue&type=template&id=44dbe41a&scoped=true"
import script from "./DiscountSale.vue?vue&type=script&lang=js"
export * from "./DiscountSale.vue?vue&type=script&lang=js"

import "./DiscountSale.vue?vue&type=style&index=0&id=44dbe41a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dbe41a"]])

export default __exports__